<template>
  <div>
    <div class="d-flex justify-content-center mb-3">
      <ul class="nav nav-pills">
        <li class="nav-item" v-if="false">
          <a class="nav-link" href="#" :class="( aba == 'visao' || !aba ) ? 'active' : ''" @click.prevent="abrir('visao')">
            Visão Geral
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" :class="( aba == 'internados' || !aba ) ? 'active' : ''" @click.prevent="abrir('internados')">
            Internados
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" :class="( aba == 'leitos' || !aba ) ? 'active' : ''" @click.prevent="abrir('leitos')">
            Leitos
          </a>
        </li>
      </ul>
    </div>

    <visao-geral-internacao v-if="aba == 'visao'" />
    <internados v-if="aba == 'internados'" />        
    <leitos v-if="aba == 'leitos'" />        
  </div>
</template>

<script>
import VisaoGeralInternacao from './VisaoGeralInternacao.vue';
import Internados from './Internados.vue';
import Leitos from './Leitos.vue';

export default {
  data() {
    return {
      dados: null,
      parms: null, 
      outras: [], 
    };
  },

  components: { 
    VisaoGeralInternacao, 
    Internados,
    Leitos,
  },

  props: ['aba'],

  methods: { 
      abrir(aba) { 
          if ( aba != this.aba ) { 
            this.$router.push({ path: '/internacao/' + aba });
          }
      },
  },

  mounted() { 
      //
  }
}
</script>